import { render } from "./cart_display.vue?vue&type=template&id=3851e657"
import script from "./cart_display.vue?vue&type=script&lang=js"
export * from "./cart_display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__